import type { TFunction } from 'i18next';

import type { PlanKey } from '../hooks/usePlanStatus';

function formatPlanRenewalDate(periodEnd: string | null, locale?: string): string | null {
  if (!periodEnd) return null;
  const end = new Date(periodEnd);
  if (Number.isNaN(end.getTime())) return null;
  return end.toLocaleDateString(locale, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function getLocalizedPlanLabel(planKey: PlanKey, t: TFunction): string {
  switch (planKey) {
    case 'free':
      return t('views.pricing.planFree', 'Free');
    case 'monthly':
      return t('views.pricing.planMonthly', 'Monthly');
    case 'quarterly':
      return t('views.pricing.planQuarterly', 'Quarterly');
    case 'halfyearly':
      return t('views.pricing.planHalfYearly', 'Half-Yearly');
    case 'legacy':
      return t('layout.planNames.legacy', 'Legacy');
    default:
      return t('views.pricing.planFree', 'Free');
  }
}

export function formatPlanTimelineLocalized(
  t: TFunction,
  periodEnd: string | null,
  daysLeft: number | null,
  isExpired: boolean,
  locale?: string,
): string | null {
  const formatted = formatPlanRenewalDate(periodEnd, locale);
  if (!formatted) return null;
  if (isExpired) {
    return t('layout.planTimeline.expired', { defaultValue: 'Expired {{date}}', date: formatted });
  }
  if (daysLeft != null && daysLeft <= 0) {
    return t('layout.planTimeline.ended', { defaultValue: 'Ended {{date}}', date: formatted });
  }
  if (daysLeft != null && daysLeft <= 7) {
    return t('layout.planTimeline.renewsIn', {
      count: daysLeft,
      date: formatted,
    });
  }
  return t('layout.planTimeline.renews', { defaultValue: 'Renews {{date}}', date: formatted });
}
